import axios from 'axios'
let baseUrl= ''
axios.defaults.timeout = 31*1000 // 超时时间 31s
if(window.location.protocol=='https:'){
  baseUrl= 'https://service.tourbida.com/'
}else{
  baseUrl= 'http://service.tourbida.com/'
}
const request = (url = '', data = {}) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl+url, data).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}
export default request